import React from "react";
import { AlignedBoxTitle, MiniCardParagraph } from "../../../../styles/texts";
import GrayCardVertical from "../GreyRectangles/GreyCardVertical";
import ProductionPieChart from "./ProductionPieChart";

interface DailyProdCardProps {
  kWhVendidos: number;
  kWhVendidosMoney: number;
  kWhConsumidos: number;
  kWhConsumidosMoney: number;
}

const DailyProdCard: React.FC<DailyProdCardProps> = ({
  kWhVendidos, kWhVendidosMoney, kWhConsumidos, kWhConsumidosMoney
}) => {

  // para que no explote la visualizacion
  const roundedValues = {
    kWhVendidos: parseFloat(kWhVendidos.toFixed(2)),
    kWhVendidosMoney: Math.round(kWhVendidosMoney),
    kWhConsumidos: parseFloat(kWhConsumidos.toFixed(2)),
    kWhConsumidosMoney: Math.round(kWhConsumidosMoney),
  };
  
  return (
    <GrayCardVertical>
      {/* Título y Descripcion */}
      <div className="text-left flex flex-col w-full">
        <AlignedBoxTitle fontSize="18px">Producción del día</AlignedBoxTitle>
        <MiniCardParagraph>
          Toda la producción de electricidad que han generado tus paneles solares hoy,
          ya sea para consumo o para venta.
        </MiniCardParagraph>
      </div>

      {/* ProductionChartCard */}
      <div className="flex justify-center items-center bg-[#EAEBF0] rounded-[12px] text-black font-montserrat text-[16px] leading-[20px] p-4 gap-8">
        
        {/* Left info */}
        <div className="flex flex-col">
          <div><strong>Consumido</strong></div>
          <div className="flex items-center gap-1">
            <div><strong>{roundedValues.kWhConsumidos}</strong></div>
            <div>kWh</div>
          </div>
          <div className="flex items-center gap-1">
            <div><strong>${roundedValues.kWhConsumidosMoney}</strong></div>
            <div>CLP</div>
          </div>
        </div>
        
        {/* Center Chart */}
        <ProductionPieChart 
          consumido={roundedValues.kWhConsumidos} 
          vendido={roundedValues.kWhVendidos}
        />


        {/* Right Info */}
        <div className="flex flex-col items-end">
          <div><strong>Vendido</strong></div>
          
          <div className="flex items-center gap-1">
            <div><strong>{roundedValues.kWhVendidos}</strong></div>
            <div>kWh</div>
          </div>

          <div className="flex items-center gap-1">
            <div><strong>${roundedValues.kWhVendidosMoney}</strong></div>
            <div>CLP</div>
          </div>
        </div>
      
      </div>
    </GrayCardVertical>
  );
};

export default DailyProdCard;
